// extracted by mini-css-extract-plugin
export default {"root":"modal_root__Xg9HU","content":"modal_content__pMT8L","inner":"modal_inner__lf12h","header":"modal_header__TCRJj","title":"modal_title__IiETe","body":"modal_body__wsGnE"};